export class TicketFollow{
    id:number;
    ticketId:number;
    userId:number;
    ticketUserTypeId:number;

    createdBy:number;
    updatedBy:number;
    deletedBy:number;
}